import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createBusiness,
  getAllBusiness,
  switchBusiness,
  updateBusiness,
} from "../../services/services";

export const fetchBusiness = createAsyncThunk(
  "business/fetchAll",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await getAllBusiness(userId);
      // console.log("=== getAllBusiness FULL RESPONSE ===", {
      //   status: res.data.status,
      //   message: res.data.message,
      //   response: res.data.response,
      //   userId: userId,
      // });
      if (res.data.status) {
        return res.data.response || [];
      } else {
        return rejectWithValue(res.data.message || "Failed to load business");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to load business",
      );
    }
  },
);

export const handleAddBusiness = createAsyncThunk(
  "business/add",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await createBusiness(payload, config);
      if (res.data.status) {
        return res.data.response.business;
      } else {
        return rejectWithValue(res.data.message || "Failed to create business");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create business",
      );
    }
  },
);

export const handleUpdateBusiness = createAsyncThunk(
  "business/update",
  async ({ id, data }, { rejectWithValue, getState }) => {
    try {
      const res = await updateBusiness(id, data);

      if (res.data.status) {
        return res.data.response; // updated business
      } else {
        return rejectWithValue(res.data.message);
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Update failed");
    }
  },
);

const businessSlice = createSlice({
  name: "business",
  initialState: {
    list: [],
    activeBusiness: null,
    loading: false,
  },

  reducers: {
    setActiveBusiness(state, action) {
      state.activeBusiness = action.payload;
      localStorage.setItem("selectedBusiness", JSON.stringify(action.payload));
    },

    deleteBusinessFromState(state, action) {
      const deletedId = action.payload;

      state.list = state.list.filter((biz) => biz._id !== deletedId);

      if (state.activeBusiness?._id === deletedId) {
        state.activeBusiness = state.list[0] || null;

        localStorage.setItem(
          "selectedBusiness",
          JSON.stringify(state.activeBusiness),
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusiness.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.loading = false;

        // This is the most important line
        state.list = Array.isArray(action.payload) ? action.payload : [];

        // console.log(
        //   "✅ fetchBusiness fulfilled - list length:",
        //   state.list.length,
        //   "First business:",
        //   state.list[0]?.businessName,
        // );

        if (state.list.length === 0) {
          state.activeBusiness = null;
          localStorage.removeItem("selectedBusiness");
          return;
        }

        // Restore active business from localStorage if valid, otherwise set first one
        const stored = JSON.parse(
          localStorage.getItem("selectedBusiness") || "null",
        );
        const validStored =
          stored && state.list.some((biz) => biz._id === stored._id);

        if (validStored) {
          state.activeBusiness = stored;
          // console.log(
          //   "✅ Restored active business from localStorage:",
          //   stored.businessName,
          // );
        } else {
          // Fallback to first business (important for new users)
          state.activeBusiness = state.list[0];
          if (state.list[0]) {
            localStorage.setItem(
              "selectedBusiness",
              JSON.stringify(state.list[0]),
            );
            // console.log(
            //   "✅ Set first business as active:",
            //   state.list[0].businessName,
            // );
          }
        }
      })
      .addCase(handleAddBusiness.fulfilled, (state, action) => {
        // state.list.push(action.payload);
        state.list = [...state.list, action.payload];
        if (!state.activeBusiness) {
          state.activeBusiness = action.payload;
          localStorage.setItem(
            "selectedBusiness",
            JSON.stringify(action.payload),
          );
        }
      })
      .addCase(handleUpdateBusiness.fulfilled, (state, action) => {
        const updatedBiz = action.payload;

        state.list = state.list.map((biz) =>
          biz._id === updatedBiz._id ? updatedBiz : biz,
        );

        if (state.activeBusiness?._id === updatedBiz._id) {
          state.activeBusiness = updatedBiz;
          localStorage.setItem("selectedBusiness", JSON.stringify(updatedBiz));
        }
      });
  },
});

export const { setActiveBusiness, deleteBusinessFromState } =
  businessSlice.actions;
export default businessSlice.reducer;
